<!-- 待审批 -->

<template>
	<list :layout1="layout1" orderStatus="0"></list>
</template>

<script>
import list from '../list/index.vue';
export default {
	name: '',
	components: { list },
	data() {
		return {
			layout1: [
				{
					label: '预约人',
					key: 'orderUser'
				},
				{
					label: '预约时间',
					key: 'orderTimeText'
				}
			]
		};
	},
	created() {},
	mounted() {},
	methods: {}
};
</script>

<style lang="scss" scoped>
@import '@styles/variables.scss';
</style>
